import { render, staticRenderFns } from "./Publisher.vue?vue&type=template&id=53bc32ad&scoped=true&"
import script from "./Publisher.vue?vue&type=script&lang=js&"
export * from "./Publisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bc32ad",
  null
  
)

export default component.exports